import { getApps, initializeApp } from 'firebase/app';

/**
 * Firebase web config (client-side; secure data with Firestore/Storage rules).
 * Set REACT_APP_FIREBASE_* in .env.local / .env.development — see .env.example.
 *
 * @returns {import('firebase/app').FirebaseApp | null}
 */
export function getFirebaseApp() {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
  };

  if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
    console.warn(
      '[firebase] Missing REACT_APP_FIREBASE_* env vars. SDK init skipped.'
    );
    return null;
  }

  if (getApps().length > 0) {
    return getApps()[0];
  }

  return initializeApp(firebaseConfig);
}
